
// Web App States
import {get, writable} from 'svelte/store';
const viewMode = writable({tag: 'home'});

viewMode.get = () => {
    try {
        const localValue = JSON.parse(window.localStorage.getItem('viewMode'));
        if(localValue) viewMode.set(localValue);
    } catch {
        // Keep localStorage in sync with Svelte store if needed
        // window.localStorage.setItem('viewMode', JSON.stringify(get(viewMode)));
    }
}

viewMode.update = (value) => {
    viewMode.set(value);
    window.localStorage.setItem('viewMode', JSON.stringify(value));
}

viewMode.get();

viewMode.getAppId = () => {
    return JSON.parse(window.localStorage.getItem('viewMode'));
}


export {viewMode};
